import { render } from "./Sales-Execs.vue?vue&type=template&id=4ca47847"
import script from "./Sales-Execs.vue?vue&type=script&lang=js"
export * from "./Sales-Execs.vue?vue&type=script&lang=js"

import "./Sales-Execs.vue?vue&type=style&index=0&id=4ca47847&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__